/**
 * Al caricamento della pagina rimuove .active da .preloader.
 * Dopo 800ms rimuove .preloader dalla pagina.
 * @type type
 */
window.addEventListener("load", function(){
    const $preloader = document.querySelector('.preloader');

    if($preloader) {
        const $body = document.querySelector('body');
        const $html = document.querySelector('html');
        
        // nasconde il preloader
        $preloader.classList.remove('active');
        
        // rimuove il preloader
        setTimeout(function(){$preloader.parentElement.removeChild($preloader);},800);
    }

});